// Détection du domaine d'entrée — identité par domaine (marque BentSkin Go vs Nold Go).
export function currentHost() {
  if (typeof window === "undefined") return "";
  return (window.location.hostname || "").toLowerCase();
}

// Vrai si l'utilisateur arrive via un domaine Nold Go (noldgo.com, www.noldgo.com,
// admin.noldgo.com, ou un preview du type noldgo-test.preview.emergentagent.com).
export function isNoldDomain() {
  return /noldgo/i.test(currentHost());
}

// Vrai si l'utilisateur arrive via un domaine BentSkin Go (bentskingo.com,
// www.bentskingo.com, ou un preview associé).
export function isBentskinDomain() {
  return /bentskingo/i.test(currentHost());
}

// Email de contact affiché — dépend du domaine d'entrée.
export function contactEmail() {
  return isNoldDomain() ? "contact@noldgo.com" : "contact@bentskingo.com";
}

// Nom de la marque affiché — dépend du domaine d'entrée.
export function brandName() {
  return isNoldDomain() ? "Nold Go" : "BentSkin Go";
}

